/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function FixedAssetsRegisterInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;

    // Tự động tính cột 3 = cột 1 * cột 2 / 100 (Mức khấu hao)
    if (field === "historicalCost" || field === "depreciationRate") {
      const cost = parseFloat(newDetails[index].historicalCost) || 0;
      const rate = parseFloat(newDetails[index].depreciationRate) || 0;
      newDetails[index].depreciationAmount = (cost * rate) / 100;
    }

    setFieldValue("details", newDetails);
  };

  // Tính tổng cộng tự động mỗi khi details thay đổi
  useEffect(() => {
    const totalCost = details.reduce((acc, row) => acc + (parseFloat(row.historicalCost) || 0), 0);
    const totalDep = details.reduce((acc, row) => acc + (parseFloat(row.depreciationAmount) || 0), 0);
    const totalAccum = details.reduce((acc, row) => acc + (parseFloat(row.accumulatedDepreciationUntilReduction) || 0), 0);

    setFieldValue("totalHistoricalCost", totalCost);
    setFieldValue("totalDepreciationAmount", totalDep);
    setFieldValue("totalAccumulatedDepreciation", totalAccum);
  }, [details]);

  const addRow = () => {
    const template = {
      ordinalNumber: String(details.length + 1).padStart(2, "0"),
      increaseDocNumber: "",
      increaseDocDate: "",
      assetName: "",
      manufacturingCountry: "",
      useMonthYear: "",
      assetId: "",
      historicalCost: 0,
      depreciationRate: 0,
      depreciationAmount: 0,
      accumulatedDepreciationUntilReduction: 0,
      decreaseDocNumber: "",
      decreaseDocDate: "",
      decreaseReason: "",
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    const newDetails = details.filter((_, i) => i !== index).map((row, idx) => ({
      ...row,
      ordinalNumber: String(idx + 1).padStart(2, "0"),
    }));
    setFieldValue("details", newDetails);
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "12px", lineHeight: "1.4" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "10px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "12px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "12px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "11px", marginTop: "10px", marginBottom: "10px" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "28px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 3px", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 3px", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "35%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "65%" }}>
          <div style={{ fontWeight: "bold", fontSize: "13px" }}>Mẫu số S21-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "10px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "15px" }}>SỔ TÀI SẢN CỐ ĐỊNH</h2>
        <div style={{ marginTop: 5, fontWeight: "bold" }}>
          Năm: <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
        <div style={{ marginTop: 5 }}>
          Loại tài sản: <input disabled={containView} style={{ ...s.inputDotted, width: "250px" }} value={values.assetType} onChange={(e) => handleChangeField("assetType", e.target.value)} />
        </div>
      </div>

      {/* TABLE 15 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "30px" }} rowSpan={2}>Số TT</th>
              <th style={s.th} colSpan={7}>Ghi tăng tài sản cố định</th>
              <th style={s.th} colSpan={3}>Khấu hao tài sản cố định</th>
              <th style={s.th} colSpan={3}>Ghi giảm tài sản cố định</th>
              {!containView && <th style={{ ...s.th, width: "25px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={s.th} rowSpan={2}>Tên, đặc điểm, ký hiệu TSCĐ</th>
              <th style={{ ...s.th, width: "50px" }} rowSpan={2}>Nước sản xuất</th>
              <th style={{ ...s.th, width: "55px" }} rowSpan={2}>Tháng năm đưa vào sử dụng</th>
              <th style={{ ...s.th, width: "50px" }} rowSpan={2}>Số hiệu TSCĐ</th>
              <th style={{ ...s.th, width: "85px" }} rowSpan={2}>Nguyên giá</th>
              
              <th style={{ ...s.th, width: "45px" }} rowSpan={2}>Tỷ lệ khấu hao (%)</th>
              <th style={{ ...s.th, width: "85px" }} rowSpan={2}>Mức khấu hao</th>
              <th style={{ ...s.th, width: "85px" }} rowSpan={2}>Khấu hao đã tính đến khi ghi giảm TSCĐ</th>
              
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={s.th} rowSpan={2}>Lý do giảm TSCĐ</th>
            </tr>
            <tr>
              <th style={s.th}>A</th>
              <th style={{ ...s.th, width: "50px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "60px" }}>Ngày, tháng</th>
              <th style={{ ...s.th, width: "50px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "60px" }}>Ngày, tháng</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>E</th>
              <th style={s.th}>G</th>
              <th style={s.th}>H</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>I</th>
              <th style={s.th}>K</th>
              <th style={s.th}>L</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {details.map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.ordinalNumber} onChange={(e) => handleChangeTable(idx, "ordinalNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.increaseDocNumber} onChange={(e) => handleChangeTable(idx, "increaseDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.increaseDocDate} onChange={(e) => handleChangeTable(idx, "increaseDocDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.assetName} onChange={(e) => handleChangeTable(idx, "assetName", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.manufacturingCountry} onChange={(e) => handleChangeTable(idx, "manufacturingCountry", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.useMonthYear} onChange={(e) => handleChangeTable(idx, "useMonthYear", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.assetId} onChange={(e) => handleChangeTable(idx, "assetId", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.historicalCost} onChange={(e) => handleChangeTable(idx, "historicalCost", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableCenter} value={item.depreciationRate} onChange={(e) => handleChangeTable(idx, "depreciationRate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.depreciationAmount} onChange={(e) => handleChangeTable(idx, "depreciationAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.accumulatedDepreciationUntilReduction} onChange={(e) => handleChangeTable(idx, "accumulatedDepreciationUntilReduction", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.decreaseDocNumber} onChange={(e) => handleChangeTable(idx, "decreaseDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.decreaseDocDate} onChange={(e) => handleChangeTable(idx, "decreaseDocDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.decreaseReason} onChange={(e) => handleChangeTable(idx, "decreaseReason", e.target.value)} /></td>
                
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
            {/* DÒNG CỘNG */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={{ ...s.td, textAlign: "center" }} colSpan={7}>Cộng</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "3px" }}>{fmt(values.totalHistoricalCost)}</td>
              <td style={s.td}>X</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "3px" }}>{fmt(values.totalDepreciationAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "3px" }}>{fmt(values.totalAccumulatedDepreciation)}</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm TSCĐ</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: INFO */}
      <div style={{ marginTop: "10px" }}>
        <div style={s.rowLabel}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => handleChangeField("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div style={s.rowLabel}>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "130px" }} value={values.openingDate} onChange={(e) => handleChangeField("openingDate", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "25px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "10px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "140px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "10px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "140px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "11px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "45px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "10px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "180px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
